export default {
  auth: {
    loginPageTitle: 'Login',
    registerPageTitle: 'Register',
    accountSetupPageTitle: 'Account Setup',
    forgotPasswordPageTitle: 'Forgot Password',
    resetPasswordPageTitle: 'Reset Password',
  },
  settings: {
    accountSettingsPageTitle: 'Account settings',
    organisationPageTitle: 'Organisation',
    roleCapabilitiesPageTitle: 'Role capabilities',
  },
  projects: {
    projectsPageTitle: 'Projects',
    createSitePageTitle: 'Create site',
    createProjectPageTitle: 'Create project',
    createClientVariationPageTitle: 'Create Client Variation',
    sitesPageTitle: 'Sites',
    boqPageTitle: 'Site BOQ',
    boqCartPageTitle: 'BOQ Cart',
    confirmRequestsPageTitle: 'Confirm requests',
    projectCashflowPageTitle: 'Project cashflow',
    siteCashflowPageTitle: 'Site cashflow',
    claimSheetPageTitle: 'Generate Claim Sheet',
    lineItemHistoryTitle: 'Item History',
  },
  vendors: {
    vendorsPageTitle: 'Vendors',
    databaseVendorsPageTitle: 'Database Vendors',
    createBOQVendor: 'Add Budget Control vendor',
    createCustomVendor: 'Add custom vendor',
    vendorItemsPageTitle: 'Item list',
    addVendorItem: 'Add vendor item',
  },
  accounts: {
    accountsPageTitle: 'Accounts',
    accountDetailsPageTitle: 'Account Details',
  },
  orders: {
    ordersPageTitle: 'Orders',
    claimsPageTitle: 'Claims',
    createNewPageTitle: 'Create new',
    /** Names the destination, unlike `createNewPageTitle` — a crumb reading "Create new" says
     * nothing about where it leads. */
    createNewOrderBreadcrumb: 'Create new order',
    createNewClaimBreadcrumb: 'Create new claim',
    bulkOrdersPageTitle: 'Bulk Orders',
    createBulkOrderPageTitle: 'Create bulk order',
    /** Per-step titles, so the document title tracks the routed child rather than the shell. */
    createBulkOrderItemsPageTitle: 'Create bulk order — items',
    createBulkOrderSitesPageTitle: 'Create bulk order — sites',
    createBulkOrderAllocatePageTitle: 'Create bulk order — allocate',
    createBulkOrderPaymentPageTitle: 'Create bulk order — payment',
    createBulkOrderReviewPageTitle: 'Create bulk order — review',
  },
  clients: {
    pageTitles: {
      dashboard: 'Client Dashboard',
      variations: 'Client Variations',
    },
    navigationLabel: 'Approvals',
  },
  dashboardPageTitle: 'Dashboard',
  createOrgPageTitle: 'Create organisation',
  giveFeedback: 'Give feedback',
};
